"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_TYPE_2 = void 0;
const DIGITAL = 'DIGITAL';
const PHYSICAL = 'PHYSICAL';
const SUBSCRIPTION = 'SUBSCRIPTION';
exports.PRODUCT_TYPE_2 = {
    DIGITAL,
    PHYSICAL,
    SUBSCRIPTION
};
//# sourceMappingURL=productType2.js.map